import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=7dc2c659&"
import script from "./AssetManager.vue?vue&type=script&lang=js&"
export * from "./AssetManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports